import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import SubscriptionList from "../../features/manageSubscriptions/subscriptionList";
import { isValidInput } from "../../utils/validations";
import IfCan from "../../components/IfCan";

const ManageSubscriptions = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <IfCan module="Manage Subscriptions" action="view">
        <div className="main_title">
          <h1>Subscription & Plan Management</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Subscription & Plan Management
          </p>
        </div>

        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                onChange={(val: any) => {
                                  if (isValidInput(val.target.value)) {
                                    setSearchTerm(val.target.value);
                                  }
                                }}
                placeholder="Search..."
              />
            </div>
          </div>

          <SubscriptionList searchItem={searchTerm} />

        </div>
      </IfCan>
    </>
  );
};

export default ManageSubscriptions;
